// Quiz config — Spanish-first (Mexican audience). Adapts question wording to event type.

export const EVENTS = [
  { key: "boda", label: "Mi boda", hint: "El día que dirás 'sí'." },
  { key: "xv-anos", label: "Mis XV años", hint: "Tu noche de protagonista." },
  { key: "graduacion", label: "Mi graduación", hint: "Cierre de un capítulo." },
  { key: "cena", label: "Cena o evento social nocturno", hint: "Galas, premieres, bodas como invitada." },
  { key: "invitada-diurno", label: "Invitada · evento diurno", hint: "Brunch, jardín, ceremonia de día." },
  { key: "invitada-comida", label: "Invitada · comida", hint: "Comida de oficina, baby shower, despedida." },
  { key: "concurso-belleza", label: "Concurso de belleza", hint: "Certamen, pasarela, talento." },
  { key: "sesion-foto", label: "Sesión fotográfica", hint: "Editorial, embarazo, marca personal." },
  { key: "otro", label: "Otro momento especial", hint: "Cuéntame en el formulario final." },
];

// Personality questions (Q1–Q5) — universal, lightly contextual
export const PERSONALITY = (eventLabel) => [
  {
    id: "q1",
    title: `Cuando piensas en ${eventLabel.toLowerCase()}, ¿qué emoción predomina?`,
    options: [
      { v: "alegria", label: "Alegría desbordante" },
      { v: "nervios", label: "Nervios y mariposas" },
      { v: "calma", label: "Calma absoluta" },
      { v: "anticipacion", label: "Anticipación electrizante" },
      { v: "mezcla", label: "Una mezcla de todo a la vez" },
    ],
  },
  {
    id: "q2",
    title: "Tu estilo personal se parece más a…",
    options: [
      { v: "minimalista", label: "Minimalista · líneas limpias, poco maquillaje, mucha piel" },
      { v: "romantico", label: "Romántico · velos, rosas, luz cálida" },
      { v: "editorial", label: "Editorial · concepto, color, hacer foto" },
      { v: "clasico", label: "Clásico atemporal · Audrey, Grace, mi abuela en sus 20s" },
      { v: "atrevido", label: "Atrevido · ojos delineados, labio rojo, sin miedo" },
    ],
  },
  {
    id: "q3",
    title: "En cámara prefieres verte…",
    options: [
      { v: "tu-mas", label: "Como yo misma, pero la mejor versión" },
      { v: "transformada", label: "Transformada, casi otra persona" },
      { v: "epoca", label: "Inspirada en una época: años 20, 60, 90" },
      { v: "sofisticada", label: "Una versión más sofisticada de mí" },
      { v: "magnetica", label: "Magnética: imposible mirar a otro lado" },
    ],
  },
  {
    id: "q4",
    title: "Lo que más te preocupa hoy del look es…",
    options: [
      { v: "duracion", label: "Que dure todas las horas que necesito" },
      { v: "natural", label: "Que no se vea cargado, que se vea yo" },
      { v: "fotos", label: "Que las fotos salgan impecables" },
      { v: "combine", label: "Que combine con el vestido y la decoración" },
      { v: "estres", label: "El estrés de los preparativos del día" },
    ],
  },
  {
    id: "q5",
    title: "El momento ideal del día sería…",
    options: [
      { v: "intimo", label: "Un momento íntimo: yo, mi gente, y la luz correcta" },
      { v: "entrada", label: "La entrada principal: que todos volteen" },
      { v: "fotos", label: "Una sesión fotográfica eterna" },
      { v: "baile", label: "Bailar sin parar hasta que cierren la pista" },
      { v: "recibir", label: "Recibir a cada invitada con calma" },
    ],
  },
];

// Preferences (Q6–Q10)
export const PREFERENCES = [
  {
    id: "q6",
    title: "La paleta de colores que más te enamora",
    options: [
      { v: "tierras", label: "Tierras · nudes, beige, café tostado" },
      { v: "joya", label: "Joya · bordó, plum, esmeralda" },
      { v: "rosas", label: "Rosas y coral · femenino, delicado" },
      { v: "frescos", label: "Frescos · azules, verdes, lavanda" },
      { v: "metalicos", label: "Metálicos · bronce, oro, champagne" },
    ],
  },
  {
    id: "q7",
    title: "Las flores que te representan",
    options: [
      { v: "peonias", label: "Peonías" },
      { v: "rosas", label: "Rosas" },
      { v: "lirios", label: "Lirios y orquídeas" },
      { v: "girasoles", label: "Girasoles y campo" },
      { v: "silvestres", label: "Silvestres y eucalipto" },
    ],
  },
  {
    id: "q8",
    title: "Estilo de peinado preferido",
    options: [
      { v: "ondas", label: "Suelto con ondas suaves" },
      { v: "recogido", label: "Recogido bajo y pulido" },
      { v: "halfup", label: "Half up half down" },
      { v: "trenza", label: "Trenza editorial" },
      { v: "liso", label: "Liso pulido y brillante" },
    ],
  },
  {
    id: "q9",
    title: "Sube hasta 3 fotos de inspiración (opcional)",
    type: "photos",
  },
  {
    id: "q10",
    title: "El maquillaje que te imaginas",
    options: [
      { v: "glow", label: "Glow piel — luminoso y natural" },
      { v: "smokey", label: "Smokey clásico — mirada profunda" },
      { v: "labio-rojo", label: "Labio rojo statement" },
      { v: "glam", label: "Glam con glitter — pestañas, pestañas, pestañas" },
      { v: "neutro", label: "Neutro pulido — cero pero parece todo" },
    ],
  },
];

// Final reveal scenes — each scene auto-advances ~4s
export const REVEAL_SCENES = [
  {
    img: "https://images.pexels.com/photos/8221202/pexels-photo-8221202.jpeg",
    overline: "Acto I",
    text: "Sabemos lo que es estar en tus zapatos.",
  },
  {
    img: "https://images.unsplash.com/photo-1487412947147-5cebf100ffc2?crop=entropy&cs=srgb&fm=jpg&q=85",
    overline: "Acto II",
    text: "Los nervios, la emoción, el estrés.",
  },
  {
    img: "https://images.unsplash.com/photo-1503236823255-94609f598e71?crop=entropy&cs=srgb&fm=jpg&q=85",
    overline: "Acto III",
    text: "Cada detalle, cada hora, cada mirada.",
  },
  {
    img: "https://images.pexels.com/photos/33976561/pexels-photo-33976561.jpeg",
    overline: "El momento",
    text: "No esperes a que el calendario decida por ti.",
    accent: true,
  },
  {
    img: "https://images.unsplash.com/photo-1522337360788-8b13dee7a37e?crop=entropy&cs=srgb&fm=jpg&q=85",
    overline: "Tu decisión",
    text: "Reserva hoy — y respira el resto del camino.",
  },
  {
    img: "https://images.pexels.com/photos/33976561/pexels-photo-33976561.jpeg",
    overline: "Compromiso",
    text: "Queremos estar ahí. Tomar la carga, devolverte el día.",
  },
];

export const tQuiz = {
  start_overline: "Quiz personalizado · 100% gratis",
  start_title: "Diseñemos tu look juntas.",
  start_sub:
    "10 preguntas. 3 minutos. Al final te entrego una propuesta visual de cortesía + un descuento que solo verás aquí.",
  start_cta: "Empezar quiz",
  event_title: "¿Cuál es tu momento?",
  event_sub: "Selecciona el evento para que las preguntas se adapten a ti.",
  back: "← Anterior",
  next: "Siguiente",
  see_results: "Ver mis resultados",
  upload_label: "Selecciona o suelta tus imágenes (máx 3)",
  upload_hint: "JPG / PNG · se ajustan automáticamente",
  skip: "Saltar este paso",
  progress: "Pregunta",
  // Result form
  form_overline: "Tu propuesta personalizada",
  form_title: "Te la enviamos por email.",
  form_sub: "Y si agendas tu entrevista hoy, activamos el descuento.",
  form_name: "Nombre completo",
  form_email: "Email",
  form_phone: "Teléfono / WhatsApp",
  form_schedule: "Sí, quiero agendar mi entrevista inicial ahora (20% en mi servicio · 10% para mis invitadas).",
  form_submit: "Ver mi mood board",
  // Success / Results
  success_overline: "Tu propuesta de cortesía",
  success_title: "Tu mood board personal",
  success_sub:
    "También te lo enviamos por email. Llévalo a tu entrevista para activar el 20% en tu servicio y el 10% de tus invitadas.",
  success_book: "Agendar por WhatsApp",
  success_home: "Volver al inicio",
  res_event: "Tu momento",
  res_personality: "Tu personalidad",
  res_preferences: "Tus preferencias visuales",
  res_inspiration: "Tu inspiración personal",
  res_code: "Tu código de cortesía",
  res_palette: "Paleta",
  res_flowers: "Flores",
  res_hair: "Peinado",
  res_makeup: "Maquillaje",
};
